module.exports = __webpack_public_path__ + "img/icon1.d3984f7b.png";